import { Box, Stack, Typography } from '@mui/material';
import LaunchAppButton from 'components/LaunchAppButton';
import { ConfigContext } from 'context';
import InstavisionButton from 'coreComponents/Button/Button';
import PopUp from 'coreComponents/PopUp/PopUp';
import { AppBridge } from 'infrastructure/appBridge/appBridge';
import { APP_BRIDGE_CALLBACKS } from 'infrastructure/appBridge/appCallBacks';
import { birdAssets } from 'partners/birdAssets';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PopupTypes } from 'typings/popUpTypes';
import { isRunningInWebView } from 'utils/webviewHelpers';
import { PopupIllustrationImage } from '../popupIllustrationStyle';

interface TPlanActivatedPopupProps {
  isUpgrade: boolean;
  isFreeTrial: boolean;
}

function PlanActivatedPopupBirdFeeder(props: TPlanActivatedPopupProps) {
  const { isUpgrade, isFreeTrial } = props;
  const [isPopUpOpen, setIsPopUpOpen] = useState(true);
  const config = useContext(ConfigContext);

  const { t } = useTranslation('translation', {
    keyPrefix: 'components.birdPaymenSuccessPopup'
  });

  // To do: Add App Callback here to take to live stream
  const handlePopUpBackButtonClick = () => {
    setIsPopUpOpen(false);
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.UPDATED_SUBSCRIPTION);
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.CLOSE_IN_APP_WEBVIEW);
  };

  const isWebViewPresent = isRunningInWebView();

  return (
    <PopUp isOpen={isPopUpOpen} type={PopupTypes.TYPE2}>
      <Stack direction="column" alignItems="center" marginBottom="30px">
        <Stack marginBottom="12px">
          <PopupIllustrationImage
            src={birdAssets.birdPlanActivatedIllustration}
            alt="free-trial-activated"
          />
          {/* <FreeTrialActivation width="300" height="250" /> */}
        </Stack>
        {isFreeTrial && (
          <Typography variant="title1" paddingBottom="12px">
            {t(!isUpgrade ? 'freeTrialConfirmedTitle' : 'upgradeTitle')}
          </Typography>
        )}
        {!isFreeTrial && (
          <Typography variant="title1" paddingBottom="12px">
            {t(isUpgrade ? 'upgradeTitle' : 'paymentConfirmedTitle')}
          </Typography>
        )}
        <Box textAlign="center">
          <Typography variant="body2" padding="0px 12px" color="text.secondary">
            {!isFreeTrial ? (
              <>
                {t(
                  isUpgrade
                    ? 'successUpgrade'
                    : 'thankYouForPurchaseNonFreeTrial',
                  {
                    productName: config.nameOfCompany
                  }
                )}
              </>
            ) : (
              <>
                {t('thankYouForPurchase', {
                  productName: config.nameOfCompany
                })}
              </>
            )}
          </Typography>
        </Box>
      </Stack>
      <Stack direction="column" alignItems="Stretch" marginBottom="6px">
        {isWebViewPresent ? (
          <InstavisionButton
            sx={{
              marginBottom: '16px'
            }}
            onClick={() => handlePopUpBackButtonClick()}
          >
            {t('goHome')}
          </InstavisionButton>
        ) : (
          <LaunchAppButton />
        )}
      </Stack>
    </PopUp>
  );
}
export default PlanActivatedPopupBirdFeeder;
